export default __webpack_public_path__ + "static/yassine-khalfalli-roc-image-a92a4176c2e357601a2bcd7c6e7eef8a.jpg";